module.exports = __webpack_public_path__ + "img/person.8b07c9e6.jpg";